var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.166992,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#E39B2B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 11.8335H10.8333C10.2145 11.8335 9.621 12.0793 9.18342 12.5169C8.74583 12.9545 8.5 13.548 8.5 14.1668V16.5002H31.8333V14.1668C31.8333 13.548 31.5875 12.9545 31.1499 12.5169C30.7123 12.0793 30.1188 11.8335 29.5 11.8335ZM8.5 25.8335C8.5 26.4523 8.74583 27.0458 9.18342 27.4834C9.621 27.921 10.2145 28.1668 10.8333 28.1668H29.5C30.1188 28.1668 30.7123 27.921 31.1499 27.4834C31.5875 27.0458 31.8333 26.4523 31.8333 25.8335V18.8335H8.5V25.8335ZM12 23.5002H15.5C15.8094 23.5002 16.1062 23.6231 16.325 23.8419C16.5437 24.0607 16.6667 24.3574 16.6667 24.6668C16.6667 24.9762 16.5437 25.273 16.325 25.4918C16.1062 25.7106 15.8094 25.8335 15.5 25.8335H12C11.6906 25.8335 11.3938 25.7106 11.175 25.4918C10.9562 25.273 10.8333 24.9762 10.8333 24.6668C10.8333 24.3574 10.9562 24.0607 11.175 23.8419C11.3938 23.6231 11.6906 23.5002 12 23.5002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit_card.f58fddda503865626d568b4f5be27c3b.svg";
export { ForwardRef as ReactComponent };